import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
    searchbox: {
      width: '100%',
      height: '40px',
      borderRadius: '4px',
      border: '1px solid #DEE5EF',
      padding: '13.25px',
      fontSize: '14px',
    },
    select_menu: {
      fontFamily: "Inter !important",
      marginTop: "3px",
      '& li': {
        fontSize: "14px",
        color: "#394A64",
        padding: "12px 16px",
        lineHeight: "19.6px",
        fontFamily: "Inter !important",
      },
      '& ul.MuiMenu-list': {
        padding: "0px"
      },
      '& .MuiPaper-root': {
        borderRadius: "4px",
        overflowY: "overlay"
      }
    },
    select_menu_sort: {
      '& .MuiPaper-root': {
        width: '153px'
      }
    },
    searchbox_menu: {
      width: '100%',
      minWidth: '169px',
      height: '40px',
      borderRadius: '4px',
      border: '1px solid #B7C0C6',
      padding: '13.25px',
      fontSize: '14px',
      color: '#202020',
      fontWeight: '400',
      letterSpacing: '-0.02em',
      "& input::placeholder": {
        color: '#909AA4',
        fontWeight: '500',
      }
    },
  }));